const CALLS_STATUSES = new WeakMap<Object, Map<string, boolean>>();

export function skipWhilePreviousCall(): MethodDecorator {
    return function (target: Object, methodName: string, descriptor: PropertyDescriptor): PropertyDescriptor {
        let originalFunction = descriptor.value;
        descriptor.value = async function (...args: Array<any>) {
            let instanceStatuses = CALLS_STATUSES.get(this);
            if (!instanceStatuses) {
                CALLS_STATUSES.set(this, new Map());
                instanceStatuses = CALLS_STATUSES.get(this);
            }
            let methodStatus = instanceStatuses.get(methodName);
            if (!methodStatus) {
                instanceStatuses.set(methodName, true);
                let result = await originalFunction.apply(this, args);
                instanceStatuses.set(methodName, false);
                return result;
            }
        };
        return descriptor;
    };
}

export function checkProperty(property: string | symbol): MethodDecorator {
    return function (target, prop, descriptor: PropertyDescriptor): PropertyDescriptor {
        let originalValue = descriptor.value;
        descriptor.value = function (...args) {
            return this.hasOwnProperty(property) && this[property] !== undefined && this[property] !== null
                ? originalValue.apply(this, args)
                : undefined;
        };
        return descriptor;
    };
}

export function debounce(delay: number = 300): MethodDecorator {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const timeoutKey = Symbol();

        const original = descriptor.value;

        descriptor.value = function (...args) {
            clearTimeout(this[timeoutKey]);
            this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
        };

        return descriptor;
    };
}
